import React from 'react'
import { 
    ItemBox, PremiumContainer, StartButtonWrapper, 
    PremiumTitle, PremiumPrice, CheckBoxIcon,
    StartPlanButton, LineHor, StartTrialContainer, STHeader
 } from '../settings.styled'
import { useDispatch, useSelector } from 'react-redux'
import { setSelectPlan, setViewSubscribeModal, setSubscribeIntent } from 'features/billing/billingSlice'
import SpinnerSmall from 'components/SpinnerSmall' 
import dayjs from 'dayjs';
import { FaCheckCircle } from "react-icons/fa";
import { toast } from 'react-toastify'
import styled from 'styled-components';
import { useTranslation } from 'react-i18next'

export default function StartSubscription() {
    const { t } = useTranslation('settings')
    const dispatch = useDispatch()
    const { 
        selectedPlan, 
        trialAvailable,
        trialEndDate,
        paymentIntentLoading,
    } = useSelector((state) => state.billing)

    const gracePeriodEndDate = dayjs(trialEndDate).add(3, 'days').format('MMMM D, YYYY') 
    const today = dayjs()
    const gracePeriodEnd = dayjs(gracePeriodEndDate)  
    const date = dayjs(trialEndDate).format('MMMM D, YYYY')

    const handleConfirmSelectedPlan = () => {

        if(!selectedPlan){
            toast.error(t('billing.selectPlan'))
            return
        }

        dispatch(setSubscribeIntent({
            selectedPlan: selectedPlan, 
        }))
        dispatch(setViewSubscribeModal())
    }

    return (
        <StartTrialContainer>  
            <STHeader>
                <span>{t('billing.headline')}</span>
                {
                    trialAvailable &&
                    <span>{t('billing.trialHeadline')}</span>
                }
            </STHeader>
            <PremiumContainer>
                <ItemBox
                    onClick={() => { dispatch(setSelectPlan('monthly')) }}
                    selected={selectedPlan === 'monthly'}
                    >
                        {
                            selectedPlan === 'monthly' &&
                            (
                                <CheckBoxIcon> <FaCheckCircle size={25}  /> </CheckBoxIcon>
                            )
                        }

                    <PremiumTitle>{t('billing.premium')}</PremiumTitle>
                    <PremiumPrice>
                        <span><b>$15</b> <span>{t('billing.perMonth')}</span></span>
                        <span>{t('billing.billedMonthly')}</span>
                    </PremiumPrice> 
                </ItemBox>
                <ItemBox
                    onClick={() => { dispatch(setSelectPlan('yearly')) }}
                    selected={selectedPlan === 'yearly'}
                    >
                        {
                            selectedPlan === 'yearly' &&
                            (
                                <CheckBoxIcon> <FaCheckCircle size={25} /> </CheckBoxIcon>
                            )
                        } 
                    <PremiumTitle>{t('billing.premium')}</PremiumTitle>
                    <PremiumPrice>
                        <span><b>$12</b> <span>{t('billing.perMonth')}</span></span>
                        <span>{t('billing.billedYearly', { amount: '$144' })}</span>
                    </PremiumPrice>
                </ItemBox> 
            </PremiumContainer> 
            {
                trialAvailable ? (
                    <InfoWrapQW>
                        {t('billing.trialBody')}
                    </InfoWrapQW>
                )
                :
                (
                    <InfoWrapQW>
                        {t('billing.subscriptionBody')}
                    </InfoWrapQW>
                )
            }

            <StartButtonWrapper>
                <StartPlanButton
                    disabled={paymentIntentLoading}
                    onClick={handleConfirmSelectedPlan}
                    >
                    {
                        paymentIntentLoading ?
                        (
                            <SpinnerSmall />
                        )
                        : trialAvailable ? (
                            <span>{t('billing.startTrial')}</span>
                        )
                        :
                        (
                            <span>{t('billing.startSubscription')}</span>
                        )
                    } 
                </StartPlanButton>
            </StartButtonWrapper> 
        </StartTrialContainer>
    )
}

const InfoWrapQW = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    font-size: 14px;
    text-align: left;
    font-weight: 500;
    color: var(--lightThemeFontColor);
    margin-bottom: 20px;
    margin-top: 20px;
    line-height: 1.5;
`
